
import {Component, Vue} from "vue-property-decorator";
import {Route} from "vue-router";
import YetkiGecisiEkrani from "@/components/yetki-gecisi/YetkiGecisiEkrani.vue";
import {gecisDugmesiAcik, KULLANICI_IZINLERI_YOLU} from "@/components/yetki-gecisi/yetkiGecisi";

@Component({
  components: {YetkiGecisiEkrani},
  beforeRouteEnter(to: Route, from: Route, next: (cb: (vm: any) => void) => void) {
    next((vm) => {
      vm.izinlerdenGelindi = from.path === KULLANICI_IZINLERI_YOLU;
    });
  },
})
export default class YetkiGecisiView extends Vue {
  // Açılışta yönlendirilecekse ekran hiç kurulmaz: kurulsaydı önizleme isteği gider, yeni modda 409 dönünce sayfa çoktan
  // çıkmışken bilgi mesajı ve zorla /ben üretirdi.
  yonlendiriliyor = false;
  izinlerdenGelindi = false;
  donuluyor = false;

  created() {
    // Büro zaten yeni modda ya da sunucu düğmeyi kapattıysa (adres elle açıldı) geçiş yapılacak bir şey yok. Yalnız açılışta bakılır: geçiş sırasında /ben tazelenince sayfayı biz yönlendiririz.
    if (!gecisDugmesiAcik(this.$store.state.user)) {
      this.yonlendiriliyor = true;
      this.izinlereGit();
    }
  }

  // Vazgeç ve başarılı geçiş aynı yere döner; yeni modda orada yeni izin ekranı açılır. İzinlerden gelindiyse geri gidilir:
  // replace geçmişte art arda iki izinler kaydı bırakır, ilk Geri boşa gider. Çift tıklama iki adım geri gitmesin.
  izinlereDon() {
    if (this.donuluyor) {
      return;
    }
    this.donuluyor = true;
    if (this.izinlerdenGelindi) {
      this.$router.back();
      return;
    }
    this.izinlereGit();
  }

  // Geçmişe kayıt eklenmez: eklenseydi Geri bu sayfaya düşer, sayfa (büro artık yeni modda) yeniden ileri atar, Geri hiç
  // çıkamazdı.
  izinlereGit() {
    this.$router.replace(KULLANICI_IZINLERI_YOLU).catch(() => {
      // Aynı rotaya yönlendirme (NavigationDuplicated) hatası yutulur.
    });
  }
}
